import React from "react";
import "./TechPage.css";
import NavBar from "../../components/NavBar/NavBar";
import Footer from "../../components/Footer/Footer";
import PageHeader from "./techComponents/PageHeader";
import Logos from "./techComponents/Logos";
import Technologies from "./techComponents/Technologies";

const TechPage = () => {
  return (
    <div>
      <NavBar />
      <PageHeader />
      <Logos />
      <Technologies />
      <Footer />
    </div>
  );
};

export default TechPage;
